import shuffle from 'lodash/shuffle';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import WordlistLanguageSelector from './WordlistLanguageSelector';
import WordlistPreview from './WordlistPreview';
import WordlistContext, { EnrichedWord } from './_contexts/WordlistContext';
import WordlistViewModeContext, { WordlistViewMode } from './_contexts/WordlistViewModeContext';
import useWordlistWords from './_hooks/useWordlistWords';

export default function WordlistFocusMode() {
  const { t } = useTranslation();
  const words = useWordlistWords();

  const { selectedWord, setSelectedWord, cardsExpanded, setCardsExpanded } = useContext(WordlistContext);
  const { setViewMode } = useContext(WordlistViewModeContext);

  const [shuffledWords, setShuffledWords] = useState<EnrichedWord[]>();

  if (!words) return null;

  const shuffleWords = () => {
    const nextWords = shuffle(words);

    setShuffledWords(nextWords);
    setSelectedWord(nextWords[0]);
  };

  const currentWords = shuffledWords ?? words;
  const currentWordIndex = currentWords.findIndex(word => word.id === selectedWord?.id);

  return (
    <div className="wordlist-focus">
      <div className="wordlist-focus__actions" data-testid="wordlist-focus__actions">
        <button
          className="wordlist-focus__action wordlist-focus__action--return"
          onClick={() => setViewMode(WordlistViewMode.LIST)}
          data-testid="wordlist-focus__action--return"
        >
          <svg className="icon icon-return bc-icon__right" role="img">
            <use href="#icon-return" />
          </svg>
          <span className="caption-2">{t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.WORD_LIST')}</span>
        </button>
        <WordlistLanguageSelector />
        <div className="wordlist-focus__action-col">
          <button
            className="wordlist-focus__action"
            data-testid="wordlist-focus__action--expand"
            onClick={() => setCardsExpanded(!cardsExpanded)}
          >
            <svg className="icon" role="img">
              {cardsExpanded ? <use href="#icon-card-hide-all" /> : <use href="#icon-card-show-all" />}
            </svg>
          </button>
          <button
            className="wordlist-focus__action"
            data-testid="wordlist-focus__action--shuffle"
            onClick={shuffleWords}
          >
            <svg className="icon" role="img">
              <use href="#icon-shuffle" />
            </svg>
          </button>
          <span className="wordlist__badge wordlist__badge--inverted" role="status">
            {currentWordIndex + 1}/{words.length}
          </span>
        </div>
      </div>
      <div className="wordlist-focus__content">
        <WordlistPreview words={currentWords} />
      </div>
    </div>
  );
}
